<div *ngIf="loading | async">
  <app-loading></app-loading>
</div> 
<ng-container *ngIf="!(loading | async)">
<div class="container">
    <mat-card (keydown.enter)="isFormValid() && searchEquipment()">
      <h1>Home</h1>
      <p>Start by searching for your equipment</p>
  
      <mat-form-field class="full-width">
        <mat-label>Equipment ID</mat-label>
        <input matInput placeholder="Enter Equipment ID" (input)="validateEquipmentId($event)" />
      </mat-form-field>
  
      <div class="divider">
        <span class="divider-text">Or Search by</span>
      </div>
  
      <mat-form-field class="full-width">
        <mat-label>{{ (optionsStatus.make.label | async) }}</mat-label>
        <mat-select (selectionChange)="selectOption('make', $event.value)" [disabled]="!(optionsStatus.make.enabled | async)" #makeSelect="matSelect">
          <mat-option>
            <ngx-mat-select-search [formControl]="optionsStatus.make.filter" placeholderLabel="Search..." noEntriesFoundLabel="No matching Make found..."  [disableInitialFocus]="true"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let make of getFilteredOptions('make')" [value]="make">
            {{ make }}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field class="full-width">
        <mat-label>{{ (optionsStatus.model.label | async) }}</mat-label>
        <mat-select (selectionChange)="selectOption('model', $event.value)" [disabled]="!(optionsStatus.model.enabled | async)" #modelSelect="matSelect">
            <mat-option>
              <ngx-mat-select-search [formControl]="optionsStatus.model.filter" placeholderLabel="Search..." noEntriesFoundLabel="No matching Model found..."  [disableInitialFocus]="true"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let model of getFilteredOptions('model')" [value]="model">
                {{ model }}
            </mat-option>
        </mat-select>
      </mat-form-field>
        
      <mat-form-field class="full-width">
        <mat-label>{{ (optionsStatus.manualType.label | async) }}</mat-label>
        <mat-select  [(value)]="selectedOptions['manualType']" (selectionChange)="selectOption('manualType', $event.value)" [disabled]="!(optionsStatus.manualType.enabled | async)" #manualTypeSelect="matSelect">
          <mat-option>
            <ngx-mat-select-search [formControl]="optionsStatus.manualType.filter" placeholderLabel="Search..." noEntriesFoundLabel="No matching Manual Type found..."  [disableInitialFocus]="true"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let manualType of getFilteredOptions('manualType')" [value]="manualType">
            {{ manualType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      
      <div *ngIf="this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : '')) && showPVC">
        <mat-form-field class="full-width">
          <mat-label>{{ (optionsStatus.pvc.label | async) }}</mat-label>
            <mat-select (selectionChange)="selectOption('pvc', $event.value)" [disabled]="!(optionsStatus.pvc.enabled | async)" #pvcSelect="matSelect">
              <mat-option>
                <ngx-mat-select-search [formControl]="optionsStatus.pvc.filter" placeholderLabel="Search..." noEntriesFoundLabel="No matching PVC found.."  [disableInitialFocus]="true"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let pvc of getFilteredOptions('pvc')" [value]="pvc">
                  {{ pvc }}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="showSerialNumberRange">
      <mat-form-field class="full-width">
        <mat-label>{{ (optionsStatus.serialNumberRange.label | async) }}</mat-label>
        <mat-select (selectionChange)="selectOption('serialNumberRange', $event.value)" [disabled]="!(optionsStatus.serialNumberRange.enabled | async)" #serialNumberSelect="matSelect">
            <mat-option>
              <ngx-mat-select-search [formControl]="optionsStatus.serialNumberRange.filter" placeholderLabel="Search..." noEntriesFoundLabel="No matching Serial Number found..."  [disableInitialFocus]="true"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let serial of getFilteredOptions('serialNumberRange')" [value]="serial">
                {{ serial }}
            </mat-option>
        </mat-select>
        </mat-form-field>
      </div>
      <mat-error *ngIf="(optionsStatus.make.error | async) || (optionsStatus.model.error | async) || (optionsStatus.serialNumberRange.error | async) || (optionsStatus.pvc.error | async)  
       || (wrongEquipmentId | async) || (optionsStatus.manualType.error | async)" class="error-msg">
        <div class="error-msg-icon">
          <mat-icon>error</mat-icon>
        </div>
           <p>{{ (backendErrorMessage | async) }}</p>
      </mat-error>
      <mat-error *ngIf="!hasPdf" class="error-msg">
        <div class="error-msg-icon"><mat-icon>error</mat-icon></div>
        <p>This unit does not have manuals mapped to it. Please try searching by Make / Model / Serial Range.</p>
      </mat-error>
      <mat-error *ngIf="!hasPdfByMake" class="error-msg">
        <div class="error-msg-icon"><mat-icon>error</mat-icon></div>
        <p>This search by Make / Model / Serial Range does not have manuals mapped to it.</p>
      </mat-error>
  
      <app-button 
        [configKey]="isFormValid() ? 'search' : 'searchDisabled'" 
        (onClick)="searchEquipment()"></app-button>
    </mat-card>
</div>
</ng-container>